<section class="mt-2 grid gap-2">
  <form class="mx-auto mt-2 w-full max-w-2xl" (submit)="submitSearch($event)">
    <div
      class="flex items-center overflow-hidden rounded-xl border border-subtle bg-surface shadow-card"
    >
      <input
        type="search"
        [value]="queryInput()"
        (input)="updateQueryInput($event)"
        placeholder="Search numerons and collections..."
        class="w-full border-0 bg-transparent px-4 py-3 text-sm text-text outline-none placeholder:text-text-muted"
        aria-label="Search numerons and collections"
      />
      <button
        type="submit"
        class="inline-flex items-center justify-center border-l border-subtle px-4 py-3 text-text-muted transition-colors duration-200 ease-in-out hover:text-primary"
        aria-label="Run search"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          class="h-5 w-5"
        >
          <circle cx="11" cy="11" r="8" />
          <path d="m21 21-4.3-4.3" />
        </svg>
      </button>
    </div>
  </form>

  <h2 class="m-0 mt-3 text-xl font-semibold leading-tight text-text">{{ searchTitle() }}</h2>
  <hr class="mb-3 border-0 border-t border-subtle" />

  @if (!query()) {
    <p class="text-sm text-text-muted">Enter a search query to view results.</p>
  } @else if (isLoading()) {
    <p class="text-sm text-text-muted">Loading search results...</p>
  } @else if (hasError() && collections().length === 0) {
    <p class="text-sm text-text-muted">
      Search results are unavailable right now. Please try again.
    </p>
  } @else if (collections().length === 0) {
    <p class="text-sm text-text-muted">No matching numerons or collections were found.</p>
  } @else {
    <div appOrderedMasonry>
      @for (collection of collections(); track trackByCollectionId($index, collection)) {
        <div appOrderedMasonryItem>
          @if (collection.isCollection) {
            <app-collection-feed-card [collection]="collection"></app-collection-feed-card>
          } @else if (collection.numerons[0]; as numeron) {
            <app-numeron-card
              [numeron]="numeron"
              [numeronCollection]="collection"
              displayMode="feed"
            ></app-numeron-card>
          }
        </div>
      }
    </div>
  }

  @if (hasError() && collections().length > 0) {
    <p class="text-sm text-text-muted">
      More search results could not be loaded. Please try again.
    </p>
  }

  @if (isLoadingMore()) {
    <p class="text-sm text-text-muted">Loading more...</p>
  }

  @if (query() && hasMore()) {
    <div
      appInfiniteScrollSentinel
      [disabled]="isLoading() || isLoadingMore()"
      (reached)="loadMore()"
      class="h-4"
      aria-hidden="true"
    ></div>
  }
</section>
